/* eslint-disable prefer-const */
import { Role } from '@app/shared/common';
import { environment } from '../../environments/environment';
import { StaticResourses } from '../core/static/static-resources';
import { ROUTES } from './sidebar-routes.config';

/**
 * @config Define the default configuration
 * for the application to be passed through ngrx store.
 */
export let config = {
  apiUrl: environment.apiUrl,
  sidebarRoutes: ROUTES,
  static: StaticResourses,
};

/**
 * @routeAccess Define who can access the modules.
 */
export let routeAccess = {
  allRoles: [
    Role.SUPERADMIN,
    Role.COMPANY_ADMIN,
  ],
};
